export default __webpack_public_path__ + "static/brauhaus-darts-wm-24-preview-full-d97b679b4cf3add4c8614e96fa2d7c95.jpg";